import { useCallback } from "react";
import type { Participant } from "livekit-client";
import type { ParticipantMetadata } from "../types";
import { ACTION_TYPES } from "./helpers";
import { useLivekitLocalParticipant } from "./useLivekitLocalParticipant";

export const useLivekitPublishMetadata = (participant: Participant) => {
  const localParticipant = useLivekitLocalParticipant();

  return useCallback(
    async (newMetadata: ParticipantMetadata) => {
      const encoder = new TextEncoder();
      try {
        const action = JSON.stringify({
          type: ACTION_TYPES.PUBLISH_METADATA,
          payload: {
            participantId: participant.sid,
            metadata: newMetadata,
          },
        });
        await localParticipant.publishData(encoder.encode(action), {
          reliable: true,
        });
      } catch (err: any) {
        console.error("Could not publish metadata - ", err.message);
      }
    },
    [localParticipant, participant?.sid],
  );
};
